<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-user-settings-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Gestion des profils</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">

                    <div class="p-6 bg-gray-50 min-h-screen ">
                        <!-- ✅ Messages -->
                        <transition name="fade">
                            <div
                                    v-if="showSuccessMessage"
                                    class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-md"
                            >
                                {{ successMessage }}
                            </div>
                        </transition>
                        <transition name="fade">
                            <div
                                    v-if="showErrorMessage"
                                    class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-md"
                            >
                                {{ errorMessage }}
                            </div>
                        </transition>

                        <!-- ✅ Formulaire -->
                        <div class="bg-white p-6 rounded-2xl shadow-md mb-8">
                            <h3 class="text-lg font-semibold text-gray-700 mb-4">
                                {{ editMode ? "Modifier le profil" : "Création de Profil" }}
                            </h3>

                            <div class="grid md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label class="block text-sm font-medium text-gray-600 mb-1">Nom du profil</label>
                                    <input
                                            v-model.trim="newProfile.name"
                                            type="text"
                                            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-indigo-400"
                                            placeholder="Ex: Administrateur"
                                    />
                                </div>
                                <div>
                                    <label class="block text-sm font-medium text-gray-600 mb-1">Description</label>
                                    <input
                                            v-model.trim="newProfile.description"
                                            type="text"
                                            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-indigo-400"
                                            placeholder="Ex: Accès complet à toutes les fonctionnalités"
                                    />
                                </div>
                            </div>

                            <h4 class="mt-6 text-md font-semibold text-gray-700 mb-2">Permissions</h4>
                            <div class="bg-gray-50 p-4 rounded-lg border border-gray-200 max-h-96 overflow-y-auto">
                                <PermissionTree :nodes="permissionsTree" @toggle="handleToggle" />
                            </div>

                            <div class="flex justify-between items-center mt-6">
                                <button
                                        @click="resetPermissions"
                                        class="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                                        :disabled="!hasAtLeastOnePermission()"
                                >
                                    Réinitialiser les permissions
                                </button>
                                <button
                                        @click="saveProfile"
                                        class="bg-indigo-600 text-white px-6 py-2 rounded-md shadow-sm transition"
                                        :class="{
                                        'hover:bg-indigo-700': canSaveProfile,
                                        'opacity-50 cursor-not-allowed': !canSaveProfile,
                                      }"
                                        :disabled="!canSaveProfile"
                                >
                                    {{ editMode ? "Mettre à jour" : "Sauvegarder" }}
                                </button>
                            </div>
                        </div>

                        <!-- ✅ Liste des profils -->
                        <div class="bg-white p-6 rounded-2xl shadow-md">
                            <h3 class="text-lg font-semibold text-gray-700 mb-4">Profils existants</h3>

                            <div v-if="!hasProfiles" class="text-center py-8 text-gray-500">
                                <i class="fas fa-users text-4xl mb-2 opacity-50"></i>
                                <p>Aucun profil enregistré</p>
                            </div>

                            <div v-else class="space-y-4">
                                <div class="overflow-y-auto max-h-80 border border-gray-200 dark:border-gray-700 rounded-md">
                                <div
                                        v-for="profile in profiles"
                                        :key="profile.id"
                                        class="border border-gray-200 rounded-xl p-4 hover:shadow-md transition"
                                >
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <h4 class="font-semibold text-indigo-600 text-lg">{{ profile.namerole }}</h4>
                                            <p class="text-gray-600">{{ profile.description }}</p>
                                            <p class="text-xs text-gray-400 mt-1">Créé le {{ profile.creele }}</p>
                                        </div>

                                        <div class="flex items-center space-x-3">
                                            <button
                                                    @click="editProfile(profile)"
                                                    class="text-blue-500 hover:text-blue-700"
                                                    title="Modifier"
                                            >
                                                <i class="bx bx-edit text-xl"></i>
                                            </button>

                                            <button
                                                    @click="deleteProfile(profile)"
                                                    class="text-red-500 hover:text-red-700"
                                                    title="Supprimer"
                                            >
                                                <i class="bx bx-trash text-xl"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="mt-3">
                                        <h5 class="text-sm font-medium text-gray-700 mb-1">Permissions accordées :</h5>
                                        <pre
                                                class="bg-gray-50 p-3 rounded-md text-xs text-gray-800 leading-relaxed font-mono overflow-x-auto whitespace-pre-wrap border border-gray-200"
                                        >
                                              {{ formatPermissions(profile.permissions) }}
                                            </pre>
                                        </div>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
                <div class="cf-dialog-foot">


                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer
                    </button>


                </div>
                </div>
            </Transition>
        </div>
    </Transition>

</template>

<script>



    import PermissionTree from "./mpermissiontree";

    const axios =require('axios');

    import {cloneobjet, mergePermissionTrees, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",
        components: {  PermissionTree },
        data() {
            return {
                profiles: [],
                newProfile: { id: null, name: "", description: "",pid:"" },
                permissionsTree: [],
                editMode: false,

                showSuccessMessage: false,
                showErrorMessage: false,
                successMessage: "",
                errorMessage: "",
                isdisplay: false,
                titlemodal: "",
            };
        },
        computed: {
            hasProfiles() {
                return this.profiles.length > 0;
            },
            canSaveProfile() {
                return (
                    this.newProfile.name.trim() !== "" &&
                    this.newProfile.description.trim() !== "" &&
                    this.hasAtLeastOnePermission()
                );
            },
        },

        methods: {
            btnmodifier(value){


                let titlemodal="Modifier le profil  "+value.namerole

                let Item={
                    pid:value.pid,
                    profil:value.namerole,
                    accessprofil:cloneobjet(value.donnerolejson),
                }

                this.$refs.modalform.show(titlemodal,"update",Item,this.dataoptions);

            },
            btnajouter(){


                let  Item= {
                    pid:'',
                    profil:'',
                    accessprofil:cloneobjet(this.niveaudacces),

                };

                let mname='Enregistrer un profil utilisateur';

                this.$refs.modalform.show(mname,"add",Item,this.dataoptions);

            },
            btnsuppression(value){

                if (value.useline===1 || value.useline==='1'){

                    toastr['error']( "Impossible de supprimer cette ligne. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT SUPPRIMER "+value.namerole+" ?";

                this.$refs.modalformsuppression.show(titlemodal,value,"");

            },
            close(){
                this.isdisplay=false;

                //this.$emit('closed');

            },
           show(){
                this.titlemodal="Liste des profils utilisateur"
                /* this.datatable=listdata
                 */

                this.loadProfiles()



            },

            //****************************************************************//
            async loadProfiles() {
                try {

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/setting/profil/'+this.$store.state.appsociete+'/allprofiluser/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            //  t.datatable=[];
                            // t.datatable=res.data.m;
                            // t.dataoptions=res.data.moptions;
                            t.profiles =res.data.m|| [];
                            t.permissionsTree=res.data.permissionstree;
                            //t.alldata=res.data.alldata;

                        }
                        else{
                            t.profiles = [] ;
                            t.permissionsTree=res.data.permissionstree;



                        }

                        t.isdisplay=true;


                    })
                    .catch((error)=>{

                            console.log("error *** ",error)
                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                 } catch (err) {
                      console.error("Erreur chargement profils :", err);
                  }
            },

            loadPermissionsTemplate() {
                // (tu peux garder ta structure actuelle ici)
                this.permissionsTree = [
                    {
                        id: "menu1",
                        label: "Gestion Foncière",
                        enabled: false,
                        children: [
                            {
                                id: "menu1-page1",
                                label: "Gestion des Parcelles",
                                enabled: false,
                                children: [
                                    {
                                        id: "menu1-page1-saisie",
                                        label: "Saisie des requérants",
                                        enabled: false,
                                        children: [
                                            { id: "add", label: "Ajouter", enabled: false },
                                            { id: "edit", label: "Modifier", enabled: false },
                                            { id: "delete", label: "Supprimer", enabled: false },
                                            { id: "view", label: "Voir", enabled: false },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: "menu1-page2",
                                label: "Levé topographique",
                                enabled: false,
                                children: [
                                    { id: "leve-add", label: "Ajouter levé", enabled: false },
                                    { id: "leve-view", label: "Voir levés", enabled: false },
                                ],
                            },
                        ],
                    },
                    {
                        id: "menu2",
                        label: "Administration système",
                        enabled: false,
                        children: [
                            {
                                id: "menu2-page1",
                                label: "Profils utilisateurs",
                                enabled: false,
                                children: [
                                    { id: "p-add", label: "Créer profil", enabled: false },
                                    { id: "p-edit", label: "Modifier profil", enabled: false },
                                    { id: "p-del", label: "Supprimer profil", enabled: false },
                                ],
                            },
                            {
                                id: "menu2-page2",
                                label: "Paramètres généraux",
                                enabled: false,
                                children: [
                                    { id: "param-view", label: "Voir paramètres", enabled: false },
                                    { id: "param-edit", label: "Modifier paramètres", enabled: false },
                                ],
                            },
                        ],
                    },
                    {
                        id: "menu3",
                        label: "Rapports et Statistiques",
                        enabled: false,
                        children: [
                            {
                                id: "menu3-page1",
                                label: "Rapports financiers",
                                enabled: false,
                                children: [
                                    { id: "rapport-view", label: "Voir rapports", enabled: false },
                                    { id: "rapport-export", label: "Exporter rapports", enabled: false },
                                ],
                            },
                            {
                                id: "menu3-page2",
                                label: "Statistiques d'usage",
                                enabled: false,
                                children: [
                                    { id: "stats-view", label: "Voir statistiques", enabled: false },
                                ],
                            },
                        ],
                    },
                ];
            },

            hasAtLeastOnePermission() {
                const check = (nodes) =>
                    nodes.some((n) => n.enabled || (n.children && check(n.children)));
                return check(this.permissionsTree);
            },

            resetPermissions() {
                const reset = (nodes) => {
                    nodes.forEach((n) => {
                        n.enabled = false;
                        if (n.children) reset(n.children);
                    });
                };
                reset(this.permissionsTree);
            },

            flattenPermissions(nodes, parent = "") {
                let flat = [];
                nodes.forEach((n) => {
                    const path = parent ? `${parent}.${n.id}` : n.id;
                    if (n.enabled) flat.push(path);
                    if (n.children) flat = flat.concat(this.flattenPermissions(n.children, path));
                });
                return flat;
            },

            formatPermissions(perms) {
                if (!Array.isArray(perms) || perms.length === 0) {
                    return "Aucune permission activée";
                }

                const walk = (nodes, prefix = "") => {
                    return nodes
                        .map((node, index) => {
                            const isLast = index === nodes.length - 1;
                            const branch = prefix + (isLast ? "└─ " : "├─ ");
                            const nextPrefix = prefix + (isLast ? "   " : "│  ");

                            const icon = node.enabled ? "✅" : "❌";
                            const line = `${branch}${node.label} ${icon}`;

                            const children =
                                node.children && node.children.length
                                    ? "\n" + walk(node.children, nextPrefix)
                                    : "";

                            return line + children;
                        })
                        .join("\n");
                };

                return walk(perms);
            },

            editProfile(profile) {
                this.newProfile = { id: null, name: profile.namerole, description: profile.description,pid:profile.pid };


                //this.permissionsTree = JSON.parse(JSON.stringify(profile.permissions));
                this.permissionsTree =mergePermissionTrees(this.permissionsTree,profile.permissions);
                this.editMode = true;
            },

            async saveProfile() {
                if (!this.canSaveProfile) {
                    this.showError("Veuillez remplir tous les champs et sélectionner au moins une permission.");
                    return;
                }

                const copy = JSON.parse(JSON.stringify(this.permissionsTree));
                const flat = this.flattenPermissions(copy);

                let  Item= {
                    pid:this.newProfile.pid,
                    name: this.newProfile.name,
                    description: this.newProfile.description,
                    permissions: copy,
                    flattenedPermissions: flat,

                };
                let url,response,
                    t=this;

                t.$store.dispatch('lancerchargement',true)

                try {
                    if (this.editMode) {

                       url=process.env.VUE_APP_API_URL+'/setting/profil/'+this.$store.state.appsociete+'/saveprofiluser/'+randomString(200);
                        response =   axios  .post(url,Item,{
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                                'csrftoken': this.$store.state.appsociete
                            } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                        })



                    }
                    else {
                         url=process.env.VUE_APP_API_URL+'/setting/profil/'+this.$store.state.appsociete+'/saveprofiluser/'+randomString(200);
                         response =   axios  .post(url,Item,{
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                                'csrftoken': this.$store.state.appsociete
                            } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                        })
                    }

                    await response
                        .then(function (res){
                            // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.showSuccess();
                                t.loadProfiles();
                                t.resetForm();


                            }
                            else{

                                let errormessage="";

                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }




                                }
                                else{
                                    errormessage=res.data.message
                                }

                                console.log("res.data.datamessage ******** ",res.data.datamessage)
                                console.log("errormessage ******** ",errormessage)


                                //t.showError(errormessage);
                                toastr['error'](errormessage,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))



                } catch (err) {
                    console.error("Erreur sauvegarde profil :", err);
                    this.showError("Erreur lors de la sauvegarde du profil.");
                }
            },

            async deleteProfile(profile) {
                if (!confirm("Confirmer la suppression de ce profil ?")) return;
                try {


                    const copy = JSON.parse(JSON.stringify(this.permissionsTree));
                    const flat = this.flattenPermissions(copy);

                    let  Item= {
                        pid:profile.pid,

                    };
                    let url,response,
                        t=this;

                    t.$store.dispatch('lancerchargement',true)


                    url=process.env.VUE_APP_API_URL+'/setting/profil/'+this.$store.state.appsociete+'/supprofil/'+randomString(200);
                    response =   axios  .post(url,Item,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })



                    await response
                        .then(function (res){
                            // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){
                                t.showSuccess("Profil supprimé avec succès !");
                                t.loadProfiles();
                                t.resetForm();


                            }
                            else{

                                let errormessage="";

                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }




                                }
                                else{
                                    errormessage=res.data.message
                                }

                                console.log("res.data.datamessage ******** ",res.data.datamessage)
                                console.log("errormessage ******** ",errormessage)


                                //t.showError(errormessage);
                                toastr['error'](errormessage,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))



                } catch (err) {
                    this.showError("Erreur lors de la suppression.");
                }
            },

            resetForm() {
                this.newProfile = { id: null, name: "", description: "" };
                this.resetPermissions();
                this.editMode = false;
            },

            showSuccess(msg) {
                if (msg) this.successMessage = msg;
                this.showSuccessMessage = true;
                setTimeout(() => (this.showSuccessMessage = false), 3000);
            },

            showError(msg) {
                this.errorMessage = msg;
                this.showErrorMessage = true;
                setTimeout(() => (this.showErrorMessage = false), 4000);
            },
            /** Gestion propagation descendante/ascendante avec contrôle */
            handleToggle(node) {

                console.log("node ******** ",node)

                // Propagation descendante
                this.propagateDown(node, node.enabled);
                // Propagation ascendante contrôlée
                this.propagateUpControlled(this.permissionsTree, node);
            },
            /** Propagation descendante : active/désactive tous les enfants */
            propagateDown(node, state) {
                //this.$set(node, 'enabled', state);
                node['enabled']=state;
                if (node.children && node.children.length) {
                    node.children.forEach((child) => {
                        this.propagateDown(child, state);
                    });
                }
            },
            /** Propagation ascendante contrôlée */
            propagateUpControlled(tree, targetNode) {
                const findParentAndUpdate = (nodes, parent = null) => {
                    for (const node of nodes) {
                        if (node === targetNode && parent) {
                            this.updateParentState(parent);
                            // Continuer la propagation vers le haut
                            this.propagateUpControlled(tree, parent);
                            break;
                        }
                        if (node.children && node.children.length) {
                            findParentAndUpdate(node.children, node);
                        }
                    }
                };
                findParentAndUpdate(tree);
            },
            /** Met à jour l'état d'un parent en fonction de ses enfants */
            updateParentState(parent) {
                if (!parent.children || parent.children.length === 0) return;

                const enabledChildren = parent.children.filter(child => child.enabled);

                if (enabledChildren.length === 0) {
                    // Tous les enfants sont désactivés
                    //this.$set(parent, 'enabled', false);
                    parent['enabled']=false;
                } else if (enabledChildren.length === parent.children.length) {
                    // Tous les enfants sont activés
                    //this.$set(parent, 'enabled', true);
                    parent['enabled']=true;
                } else {
                    // Certains enfants sont activés, d'autres non
                    //this.$set(parent, 'enabled', true); // On garde le parent activé pour montrer l'état partiel
                    parent['enabled']=true;
                }
            },


        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xl { max-width:900px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>